import { Heart } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { useFavorites } from "@/favorites/FavoritesContext";

export const FavoriteButton = ({ product, context = "", className = "w-9 h-9", size = 16 }) => {
  const { t } = useLang();
  const { isFav, toggle } = useFavorites();
  const active = isFav(product.product_id);
  const testid = context ? `fav-toggle-${context}-${product.product_id}` : `fav-toggle-${product.product_id}`;

  return (
    <button
      type="button"
      data-testid={testid}
      aria-label={active ? t("favorites.remove") : t("favorites.add")}
      aria-pressed={active}
      onClick={(e) => {
        e.stopPropagation();
        toggle(product.product_id);
      }}
      className={`flex items-center justify-center rounded-full shadow-sm transition-colors ${
        active ? "bg-gold text-black" : "bg-black/50 text-white hover:bg-gold hover:text-black"
      } ${className}`}
    >
      <Heart size={size} className={active ? "fill-current" : ""} />
    </button>
  );
};

export default FavoriteButton;
